import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { EstimateSummary } from '@/presentation/components/index.js';
import type { Complexity } from '@/shared/utils/format-status.js';

interface Props {
    title: string;
    tone?: 'primary';
    complexity: Complexity | null;
    estimatedHours: number | null;
    aiScore?: number | null;
    estimatedDeliveryDate?: string | null;
}

export function EstimateHighlightBox({ title, tone, complexity, estimatedHours, aiScore, estimatedDeliveryDate }: Props) {
    const isPrimary = tone === 'primary';
    return (
        <Box
            sx={
                isPrimary
                    ? { p: 2, borderRadius: 1, bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08), border: 1, borderColor: (theme) => alpha(theme.palette.primary.main, 0.24) }
                    : { p: 2, borderRadius: 1, bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.06), border: 1, borderColor: (theme) => alpha(theme.palette.secondary.main, 0.2) }
            }
            data-testid="estimate-highlight-box"
        >
            <Typography variant="subtitle2" fontWeight={600} color={isPrimary ? 'primary.main' : undefined} sx={{ mb: 1.5 }}>
                {title}
            </Typography>
            <EstimateSummary
                complexity={complexity}
                estimatedHours={estimatedHours}
                aiScore={aiScore}
                estimatedDeliveryDate={estimatedDeliveryDate}
                labelColor={isPrimary ? 'primary.main' : undefined}
            />
        </Box>
    );
}
